import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class DynFormDataDbTableDefinition extends DbTableDefinition {
  tableName = 'dynFormData';
  tableStructure = `(id INTEGER PRIMARY KEY,
       formId BIGINT(20) NOT NULL,
       objRef VARCHAR(45),
       objId TEXT,
       isformfinished INTEGER,
       finishRawTstamp LONG,
       formdata TEXT,
       entityCreatedTstamp LONG,
       referenceTs LONG,
       manuallysavedatleastonce BOOLEAN DEFAULT FALSE
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'extFileId',
        type: 'TEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'acukey',
        type: 'VARCHAR(255)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'acid',
        type: 'BIGINT(20)',
      });
      // KRK-45 - see the native branch below
      this.alterStatements.push({
        table: this.tableName,
        col: 'chainRootAcId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'origformdata',
        type: 'TEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'isDirty',
        type: 'BOOLEAN',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'acStatus',
        type: 'INTEGER',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'acIsLocked',
        type: 'BOOLEAN',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'draftOwnerEmpId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'draftOwnerMcId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'draftOwnerServiceJobId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'isRestoredFromDraft',
        type: 'BOOLEAN',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'cloudSyncState',
        type: 'INTEGER',
      });
      // Provenance of a taken-over cloud draft (display only)
      this.alterStatements.push({
        table: this.tableName,
        col: 'restoredFromDraftEmpId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'restoredFromDraftTstamp',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'restoredFromDraftDeviceLabel',
        type: 'VARCHAR(255)',
      });
      // Local "last edited" stamp, see lastModifiedTstamp in DynFormData
      this.alterStatements.push({
        table: this.tableName,
        col: 'lastModifiedTstamp',
        type: 'BIGINT(20)',
      });
    } else {
      this.updateStatements.set(6, [
        `ALTER TABLE ${this.tableName} ADD COLUMN extFileId TEXT;`,
      ]);

      this.updateStatements.set(16, [
        `ALTER TABLE ${this.tableName} ADD COLUMN acukey VARCHAR(255);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN acid BIGINT(20);`,
      ]);

      this.updateStatements.set(20, [
        `ALTER TABLE ${this.tableName} ADD COLUMN origformdata TEXT;`,
      ]);

      this.updateStatements.set(23, [
        `ALTER TABLE ${this.tableName} ADD COLUMN isDirty BOOLEAN;`,
      ]);

      this.updateStatements.set(27, [
        `ALTER TABLE ${this.tableName} ADD COLUMN acStatus INTEGER;`,
        `ALTER TABLE ${this.tableName} ADD COLUMN acIsLocked BOOLEAN;`,
      ]);

      this.updateStatements.set(29, [
        `ALTER TABLE ${this.tableName} ADD COLUMN draftOwnerEmpId BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN draftOwnerMcId BIGINT(20);`,
      ]);

      this.updateStatements.set(32, [
        `ALTER TABLE ${this.tableName} ADD COLUMN isRestoredFromDraft BOOLEAN;`,
      ]);

      this.updateStatements.set(34, [
        `ALTER TABLE ${this.tableName} ADD COLUMN draftOwnerServiceJobId BIGINT(20);`,
      ]);

      this.updateStatements.set(46, [
        `ALTER TABLE ${this.tableName} ADD COLUMN cloudSyncState INTEGER;`,
      ]);

      // Provenance of a taken-over cloud draft (display only)
      this.updateStatements.set(53, [
        `ALTER TABLE ${this.tableName} ADD COLUMN restoredFromDraftEmpId BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN restoredFromDraftTstamp BIGINT(20);`,
      ]);

      // Own version, v53 has already run on test devices. The device label only
      // became available with the AC's createddevicelabel (APILevel 15), which is
      // why it was not part of v53.
      this.updateStatements.set(56, [
        `ALTER TABLE ${this.tableName} ADD COLUMN restoredFromDraftDeviceLabel VARCHAR(255);`,
      ]);

      // Local "last edited" stamp - the entry lists show when a form was last
      // edited even when it has no ActivityConfirmation to read that from.
      this.updateStatements.set(61, [
        `ALTER TABLE ${this.tableName} ADD COLUMN lastModifiedTstamp BIGINT(20);`,
      ]);

      // KRK-45: stable identity of the document's AC chain. The acukey it replaces is
      // rewritten by a smart renumbering, so a row could no longer be matched to its
      // own chain after a colleague filed an earlier report.
      this.updateStatements.set(63, [
        `ALTER TABLE ${this.tableName} ADD COLUMN chainRootAcId BIGINT(20);`,
      ]);
    }
  }
}
